import React from "react";
import Grid from "@material-ui/core/Grid";
import Testimonial from "../../../Assets/Testimonial.png";
import QMark from "../../../Assets/svg/QMark.svg";

import useStyles from "./testimonialsStyling";

const Testimonials = () => {
  const classes = useStyles();
  return (
    <div className={classes.mainGrid}>
      <Grid container>
        <Grid item xs={12}>
          <div>
            <p className={classes.firstHeading}>Testimonials</p>
            <p
              className={classes.firstHeading}
              style={{ fontSize: "18px", fontWeight: 500, marginTop: 0 }}
            >
              Have a look what our clients say about our Products
            </p>
          </div>
        </Grid>
      </Grid>

      <Grid container style={{ display: "flex", marginTop: "40px" }}>
        <Grid item xs={5}>
          <img alt="Testimonials" src={Testimonial} />
        </Grid>
        <Grid item xs={7} style={{ top: "50px", transform: "translateY(15%)" }}>
          <img alt="Qoutation" src={QMark} style={{ height: "25px" }} />
          <p
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginTop: 0,
              paddingLeft: "43px",
            }}
            className={classes.firstHeading}
          >
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias
            aut, repellat ipsum facere voluptate dicta obcaecati deserunt nobis
            suscipit eaque? Lorem, ipsum dolor sit amet consectetur adipisicing
            elit. Molestias aut, repellat ipsum facere voluptate dicta obcaecati
            deserunt nobis suscipit eaque?
          </p>
          <p
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              marginTop: 0,
              float: "right",
            }}
            className={classes.firstHeading}
          >
            Gabriella Macqueen
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default Testimonials;
